import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_014.jpg';
page.images = [
  {
    imageId: 'page014_zoom0',
    rectangle: {
      x: 138,
      y: 290,
      width: 1613,
      height: 2000,
    },
    imageSrc: 'images/page014/014.jpg',
  },
];
page.games = [
  // {
  //   id: 'page007_game1',
  //   tooltip: '',
  //   icon: 'ikona_cw1',
  //   pos: {
  //     x: LEFT,
  //     y: 0,
  //   },
  // },
  {
    id: 'page997_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page007_game3',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page007_game4',
    tooltip: '',
    icon: 'ikona_cw3',
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
export default page;
